if (!customElements.get("store-locator-image-rotator")) {
  customElements.define("store-locator-image-rotator", class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll(".store-locator-card__image-slide"));
      this.current = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains("is-active")));
      this.interval = Math.max(3000, Number(this.dataset.interval) || 6000);
      this.reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
      this.handleVisibility = () => document.hidden ? this.stop() : this.start();
      document.addEventListener("visibilitychange", this.handleVisibility);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener("visibilitychange", this.handleVisibility);
    }

    start() {
      this.stop();
      if (this.slides.length < 2 || this.reduceMotion.matches || document.hidden) return;
      this.timer = window.setInterval(() => this.show(this.current + 1), this.interval);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }

    show(index) {
      this.current = index % this.slides.length;
      this.slides.forEach((slide, slideIndex) => slide.classList.toggle("is-active", slideIndex === this.current));
    }
  });
}
